import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmOrder } from '@components/templates/shoppingCart';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useData } from '@hooks/useData';
import useCartSummary from '@hooks/useCartSummary';
import { useGetCart } from '@services/useGetCart';

export function ConfirmOrderPage() {
    const { t, i18n } = useTranslation();
    const { request: requestCart, loading } = useGetCart();
    const { cart } = useData();
    const { getProductsByMerchant, formattedCart } = useCartSummary(cart?.data);

    const translations = {
        title: t('confirm-order-component.metatags.title'),
        description: t('confirm-order-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.orderConfirm,
        index: false,
    });

    const productsByMerchant = getProductsByMerchant();
    const formattedTotal = formattedCart();

    const billingAddress = {
        uuid: cart?.data?.billingAddress?.uuid ?? '',
        name: cart?.data?.billingAddress?.name ?? '',
        lastName: cart?.data?.billingAddress?.lastName ?? '',
        fiscalNumber: cart?.data?.billingAddress?.fiscalNumber ?? '',
        address: `${cart?.data?.billingAddress?.address || ''}${
            cart?.data?.billingAddress?.complement ? `, ${cart?.data?.billingAddress?.complement}` : ''
        }`,
        postalCode: `${cart?.data?.billingAddress?.postalCode || ''}${
            cart?.data?.billingAddress?.municipality ? `, ${cart?.data?.billingAddress?.municipality}` : ''
        }`,
        region: cart?.data?.billingAddress?.region ?? '',
    };

    const shippingAddress = {
        uuid: cart?.data?.delivery?.shipToAddress?.uuid ?? '',
        name: cart?.data?.delivery?.shipToAddress?.name ?? '',
        lastName: cart?.data?.delivery?.shipToAddress?.lastName ?? '',
        fiscalNumber: cart?.data?.delivery?.shipToAddress?.fiscalNumber ?? '',
        address: `${cart?.data?.delivery?.shipToAddress?.address || ''}${
            cart?.data?.delivery?.shipToAddress?.complement ? `, ${cart?.data?.delivery?.shipToAddress?.complement}` : ''
        }`,
        postalCode: `${cart?.data?.delivery?.shipToAddress?.postalCode || ''}${
            cart?.data?.delivery?.shipToAddress?.municipality ? `, ${cart?.data?.delivery?.shipToAddress?.municipality}` : ''
        }`,
        region: cart?.data?.delivery?.shipToAddress?.region ?? '',
    };

    // call requestCart to update all cart data, including shipping calculations
    useEffect(() => {
        !loading && cart?.data?.shipping === null && requestCart({ with_shipping: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cart?.data?.shipping, i18n.language]);

    return (
        <ConfirmOrder
            productsByMerchant={productsByMerchant}
            billingAddress={billingAddress}
            shippingAddress={shippingAddress}
            total={formattedTotal}
        />
    );
}
